import { baseUniDriverFactory } from '../utils/test-utils/unidriver';
import { UniDriver } from '@wix/unidriver-core';

export const browserPreviewWidgetDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),
  };
};

export type BrowserPreviewWidgetUniDriver = ReturnType<
  typeof browserPreviewWidgetDriverFactory
>;
